module.exports = __webpack_public_path__ + "static/blackHoleSun-68355f0e3b126f2ca85d1411dc40cdc5.jpg";